import { Select } from 'antd';
import { useRankOptions } from '@/hooks/useRankOptions';
import { withChosenOption } from '@/lib/selectOptions';

/**
 * The rank picker — single select.
 *
 * [P2] The fetch moved to `hooks/useRankOptions.ts` so the post-type editor's
 * multi-select can share one query. THE PUBLIC PROPS ARE UNCHANGED, deliberately: that
 * is what makes the refactor internal, and `pages/Officers/Officers.test.tsx` passing
 * untouched is the check that it was.
 */
export const RankPicker = ({
  value,
  onChange,
  disabled,
  allowClear,
}: {
  value?: string;
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
  allowClear?: boolean;
}) => {
  const { options, resolve, isFetching } = useRankOptions();

  return (
    <Select
      value={value}
      onChange={(next: string | undefined) => onChange?.(next)}
      loading={isFetching}
      disabled={disabled}
      allowClear={allowClear}
      showSearch
      optionFilterProp="label"
      placeholder="Select a rank"
      className="w-full"
      data-testid="rank-picker"
      /* ⚠️ [D4.5 §1b] A rank deactivated after it was chosen keeps its NAME here rather than
         rendering its id — `lib/selectOptions.ts`. It is not re-offered: the fallback is only
         ever the value already stored. This picker also backs a URL-driven filter on the
         officer list, where the id comes from a link somebody shared. */
      options={withChosenOption(options, value, resolve)}
    />
  );
};
